import type ArrivedQueueItemData from "~~/api/response/data/queue/ArrivedQueueItemData";
import type QueueDetailsData from "~~/api/response/data/queue/QueueDetailsData";
import ArrivedQueueItem from "~/dto/queue/ArrivedQueueItem";
import QueueHourData from "~/dto/queue/QueueHourData";

export default class QueueDetails {
  count: number;
  items: ArrivedQueueItem[];
  hourData: QueueHourData | null;

  constructor(data: QueueDetailsData) {
    this.count = data.count;
    this.items = data.items.map((data: ArrivedQueueItemData) => new ArrivedQueueItem(data));
    this.hourData = data.hour_data ? new QueueHourData(data.hour_data) : null;
  }
}
